import { h, Host } from "@stencil/core";
import state from "../store";
import { hiChar } from "../../common/hiChar";
export class GxgCard {
    constructor() {
        this.elevation = "xs";
        this.background = "white";
        this.padding = "xs";
        this.minHeight = "auto";
        this.height = "auto";
        this.maxWidth = "100%";
        this.noShadow = false;
        this.hiChar = false;
        this.filterValue = undefined;
        this.noPaddingTop = false;
        this.cardTitle = undefined;
        this.noHeaderBorder = false;
        this.titleSemibold = false;
        this.cardSubtitle = undefined;
        this.subtitleLink = undefined;
        this.subtitleIcon = undefined;
        this.cardType = "section";
        this.icon = undefined;
        this.iconColor = "auto";
        this.subtitleColor = "auto";
        this.editableTitle = false;
        this.actionable = false;
    }
    el;
    /*---  Mercury Only Tokens ---*/
    titleType = "h2";
    hasSlot = false;
    hasHeaderSlot = false;
    componentWillLoad() {
        if (this.cardType === "article") {
            this.titleType = "h2";
        }
        else if (this.cardType === "mini") {
            this.titleType = "h4";
        }
        const hasSlot = this.el.querySelector("*");
        if (hasSlot) {
            this.hasSlot = true;
        }
        const headerSlot = this.el.querySelector("[slot='header']");
        if (headerSlot) {
            this.hasHeaderSlot = true;
        }
    }
    renderCardSubtitle = () => {
        if (this.cardSubtitle && this.subtitleLink) {
            return (h("a", { class: "subtitle", href: this.subtitleLink, target: "_blank" }, this.cardSubtitle));
        }
        else if (this.cardSubtitle && !this.subtitleLink) {
            {
                return this.hiChar
                    ? hiChar(this.cardSubtitle, this.filterValue)
                    : this.cardSubtitle;
            }
        }
    };
    render() {
        return (h(Host, { role: "article", class: {
                card: true,
                mercury: state.mercury,
                "card--no-content": !this.hasSlot,
                "card--section": this.cardType === "section",
                "card--article": this.cardType === "article",
                "card--mini": this.cardType === "mini",
                "card--default": this.cardType === "default",
                "card--title": this.cardTitle !== undefined,
                "card--actionable": this.actionable &&
                    (this.cardType === "article" || this.cardType === "mini"),
                "title-semibold": this.titleSemibold,
                "card--no-shadow": this.noShadow,
                "no-header-border": this.noHeaderBorder
            }, style: {
                maxWidth: this.maxWidth,
                minHeight: this.minHeight,
                height: this.height
            } }, h("div", { role: this.actionable ? "button" : "none", class: {
                wrapper: true,
                "wrapper--header": this.cardTitle !== undefined
            } }, this.cardTitle ? (h("header", { class: "card__header" }, h("div", { class: "card__header--left" }, this.icon ? (h("gxg-icon", { type: this.icon, color: this.iconColor })) : null, h("div", { class: "card-title-wrapper" }, this.cardType === "section" ? (h("gxg-title-editable", { class: "card__title", titleType: this.titleType, value: this.cardTitle, disableEdition: !this.editableTitle })) : (h("h2", { class: "card__title" }, this.hiChar
            ? hiChar(this.cardTitle, this.filterValue)
            : this.cardTitle)))), this.cardSubtitle &&
            this.cardType !== "mini" &&
            !this.hasHeaderSlot ? (h("div", { class: "card__header--right" }, h("div", { class: "subtitle-wrapper" }, this.renderCardSubtitle()), this.subtitleIcon ? (h("gxg-icon", { type: this.subtitleIcon, color: this.subtitleColor })) : null)) : null, this.hasHeaderSlot ? (h("div", { class: "card__header--right" }, h("slot", { name: "header" }))) : null)) : null, this.hasSlot ? (h("div", { class: "content" }, h("slot", null))) : null)));
    }
    static get is() { return "gxg-card"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["card.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["card.css"]
        };
    }
    static get properties() {
        return {
            "elevation": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "elevation",
                    "resolved": "\"m\" | \"xs\"",
                    "references": {
                        "elevation": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/card/card.tsx",
                            "id": "src/components/card/card.tsx::elevation"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The card box-shadow"
                },
                "attribute": "elevation",
                "reflect": true,
                "defaultValue": "\"xs\""
            },
            "background": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "background",
                    "resolved": "\"gray-01\" | \"white\"",
                    "references": {
                        "background": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/card/card.tsx",
                            "id": "src/components/card/card.tsx::background"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The background color"
                },
                "attribute": "background",
                "reflect": true,
                "defaultValue": "\"white\""
            },
            "padding": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "padding",
                    "resolved": "\"0\" | \"l\" | \"m\" | \"s\" | \"xl\" | \"xs\" | \"xxl\" | \"xxxl\"",
                    "references": {
                        "padding": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/card/card.tsx",
                            "id": "src/components/card/card.tsx::padding"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The card padding"
                },
                "attribute": "padding",
                "reflect": true,
                "defaultValue": "\"xs\""
            },
            "minHeight": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The component min. height"
                },
                "attribute": "min-height",
                "reflect": false,
                "defaultValue": "\"auto\""
            },
            "height": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The component height"
                },
                "attribute": "height",
                "reflect": false,
                "defaultValue": "\"auto\""
            },
            "maxWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The component max. width"
                },
                "attribute": "max-width",
                "reflect": false,
                "defaultValue": "\"100%\""
            },
            "noShadow": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disables box-shadow"
                },
                "attribute": "no-shadow",
                "reflect": false,
                "defaultValue": "false"
            },
            "hiChar": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This allows to highlight any character on the card title, or subtitle."
                },
                "attribute": "hi-char",
                "reflect": false,
                "defaultValue": "false"
            },
            "filterValue": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This is the filter value needed for hiChar."
                },
                "attribute": "filter-value",
                "reflect": false
            },
            "noPaddingTop": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Remove padding from the top (applies only for the \"section\" card type)"
                },
                "attribute": "no-padding-top",
                "reflect": true,
                "defaultValue": "false"
            },
            "cardTitle": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An optional title"
                },
                "attribute": "card-title",
                "reflect": false
            },
            "noHeaderBorder": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes the header border"
                },
                "attribute": "no-header-border",
                "reflect": false,
                "defaultValue": "false"
            },
            "titleSemibold": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Card title semibold"
                },
                "attribute": "title-semibold",
                "reflect": false,
                "defaultValue": "false"
            },
            "cardSubtitle": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An optional subtitle"
                },
                "attribute": "card-subtitle",
                "reflect": false
            },
            "subtitleLink": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An optional subtitle link"
                },
                "attribute": "subtitle-link",
                "reflect": false
            },
            "subtitleIcon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An optional subtitle icon"
                },
                "attribute": "subtitle-icon",
                "reflect": false
            },
            "cardType": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "CardType",
                    "resolved": "\"article\" | \"default\" | \"mini\" | \"section\"",
                    "references": {
                        "CardType": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/card/card.tsx",
                            "id": "src/components/card/card.tsx::CardType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The card type (only for mercury)"
                },
                "attribute": "card-type",
                "reflect": false,
                "defaultValue": "\"section\""
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The card type (only for mercury)"
                },
                "attribute": "icon",
                "reflect": false
            },
            "iconColor": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "Color",
                    "resolved": "\"alwaysblack\" | \"auto\" | \"disabled\" | \"error\" | \"indeterminate\" | \"mercury\" | \"negative\" | \"onbackground\" | \"ondisabled\" | \"primary-active\" | \"primary-enabled\" | \"primary-hover\" | \"success\" | \"warning\"",
                    "references": {
                        "Color": {
                            "location": "import",
                            "path": "../icon/icon",
                            "id": "src/components/icon/icon.tsx::Color"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The icon color"
                },
                "attribute": "icon-color",
                "reflect": false,
                "defaultValue": "\"auto\""
            },
            "subtitleColor": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "Color",
                    "resolved": "\"alwaysblack\" | \"auto\" | \"disabled\" | \"error\" | \"indeterminate\" | \"mercury\" | \"negative\" | \"onbackground\" | \"ondisabled\" | \"primary-active\" | \"primary-enabled\" | \"primary-hover\" | \"success\" | \"warning\"",
                    "references": {
                        "Color": {
                            "location": "import",
                            "path": "../icon/icon",
                            "id": "src/components/icon/icon.tsx::Color"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The icon color"
                },
                "attribute": "subtitle-color",
                "reflect": false,
                "defaultValue": "\"auto\""
            },
            "editableTitle": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "It makes the title editable (only for mercury)"
                },
                "attribute": "editable-title",
                "reflect": false,
                "defaultValue": "false"
            },
            "actionable": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "It applies a different style on hover. Useful when the card is actionable (has an action attached to the click event)."
                },
                "attribute": "actionable",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=card.js.map
